<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>

        <v-flex xs7>
            <v-card >
                <v-card-text class="px-0"> <h2>Total Personas que Reportan</h2> </v-card-text>
                <v-layout row wrap>
                    <v-flex  xs2>
                        <v-icon color="blue darken-4" x-large>group</v-icon>
                    </v-flex>
                    <v-flex  xs3>
                        <v-card dense >
                            <div>
                                <div class="headline">{{data.monitoreo}}</div>
                                <span class="grey--text">Bajo Monitoreo</span>
                            </div>
                        </v-card>
                    </v-flex>
                    <v-flex  xs3>
                        <v-card dense >
                            <div>
                                <div class="headline">{{data.semana}}</div>
                                <span class="grey--text">Ultima Semana</span>
                                <h4>{{percentSemana}} %</h4>
                            </div>
                        </v-card>
                    </v-flex>
                    <v-flex  xs3>
                        <v-card dense >
                            <div>
                                <div class="headline">{{data.hoy}}</div>
                                <span class="grey--text">El día de hoy</span>
                                <h4>{{percentDia}} %</h4>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout >

            </v-card>
        </v-flex>

        <v-flex  xs5>
            <v-card raised dark color="primary">
                <v-card-text class="px-0"> <h2>Reporte Hoy: {{data.hoy_fecha}}</h2>  </v-card-text>

                <v-layout row wrap>
                    <v-flex  xs5  class="py-3">
                        <div class="headline"><h2>{{data.hoy}}</h2></div>
                    </v-flex>
                    <v-flex  xs6>
                        <v-card  raised class="ma-1" color="green">
                            <div>
                                <div class="headline">{{data['sin sintomas']}} sin sintomas</div>

                            </div>

                        </v-card>
                        <v-card color="red" class="ma-1">
                            <div>
                                <div class="headline">{{data['con sintomas']}} con sintomas</div>

                            </div>

                        </v-card>
                    </v-flex>
                </v-layout >

            </v-card>
        </v-flex>
    </v-layout >

    <v-layout row wrap class="ma-3">
        <v-flex xs7>
            <h2>Reporte Participación</h2>
            <chart-column
                  :chartOptions="chartOptions"
                  :chartSeries="chartSeries"
                  :key="chartKey"
                />
        </v-flex>
        <v-flex xs5>
            <h2>Reporte Sintomas</h2>
            <pie-chart
                :chartOptions="pieOptions"
                :chartSeries="pieSeries"
                :key="pieKey"
            />
        </v-flex>
    </v-layout>

  </v-container>
</template>
<script>
import chartColumn from '@/components/Charts/ColumnBase'
import pieChart from '@/components/Charts/PieBase'
export default {
  name: 'Dash Covid',

  components: {
    'chart-column': chartColumn,
    'pie-chart': pieChart
  },
  data () {
    return {
      backConf: {
        path: '/projects/covid/dash/',
        pathFicha: '/projects/covid/timeline/',
        page: 1
      },
      fecha: null,
      data: null,

      pieOptions: {
        chart: {
          type: 'pie'
        },
        labels: [],
        colors: [
          '#4caf50', '#f44336'
        ],

        // plotOptions: {
        //   pie: {
        //     customScale: 0.8
        //   }
        // },
        // theme: {
        //   monochrome: {
        //     color: '#FF4560',
        //     enabled: true
        //   }
        // },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'middle',
          // formatter: function (val) {
          //   return Number.parseFloat(val).toFixed(3) + "%"
          // },
          style: {
            fontSize: '14px'
          }
        },
        responsive: [{
          breakpoint: 721,
          options: {
            chart: {
              height: 450
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      pieSeries: null,
      pieKey: null,

      chartOptions: {
        chart: {
          type: 'bar',
          height: 350
        },
        colors: [
          '#1a0070', '#FAD803', '#4DF5ED', '#F2C53D', '#df040b', '#59A8D9',
          '#b3b2b2', '#f9b233',
          '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#00D9E9',
          '#FF66C3', '#546E7A', '#26a69a', '#D10CE8', '#E91E63', '#FF9800',
          '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8',
          '#A9D794', '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD',
          '#7A918D', '#BAFF29'
        ],

        plotOptions: {
          bar: {
            // horizontal: true,
            distributed: true,
            dataLabels: {
              position: 'top' // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '14px',
            colors: ['#304758']
          }
        },

        xaxis: {
          categories: [],
          title: {
            text: 'Opción'
          },
          labels: {
            show: false,
            style: {
              fontSize: '14px'
            }
          }
        },
        yaxis: {
          title: {
            text: 'Número de Encuestas'
          }
        },
        legend: {
          position: 'bottom',
          offsetY: -7
        },
        fill: {
          opacity: 1
        },
        responsive: [{
          breakpoint: 721,
          options: {
            chart: {
              height: 450
            },
            legend: {
              position: 'bottom',
              offsetY: -7
            },
            xaxis: {
              labels: {
                show: false
              }
            }
          }
        }]
      },
      chartSeries: [
        {
          name: 'Registros',
          data: null
        }
      ],
      chartKey: null

    }
  },

  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.initialize()
  },

  computed: {
    /**
         * Devuelve los valores de los identificadores de las columnas de la tabla
         * @return {[Array]} valores de los id de columnas
         */
    'percentSemana': function () {
      return ((this.data.semana / this.data.monitoreo) * 100).toFixed(2)
    },
    'percentDia': function () {
      return ((this.data.hoy / this.data.monitoreo) * 100).toFixed(2)
    }

  },

  methods: {
    initialize () {
      this.getReporte()
    },

    getReporte () {
      this.loading = true
      this.data = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.data = resp.data
          t.pieOptions.labels = ['Sin Sintomas', 'Con Sintomas']
          t.pieSeries = [t.data['sin sintomas'], t.data['con sintomas']]
          t.pieKey += 1

          t.chartOptions.labels = ['Total Monitoreo', 'Semana', 'Hoy']
          t.chartSeries[0].data = [t.data.monitoreo, t.data.semana, t.data.hoy]
          t.chartKey += 1
          // t.tableKey += 1
          // t.updateTable()
          // t.chartSeries = resp.data
          // t.chartSeries.pop()
          // t.chartOptions.yaxis.pop()
          // t.loading = false
          // t.chartKey += 1
        })
        .catch(err => console.error(err))
    }
  }
}
</script>
